import styled, { css } from 'styled-components';
import { FAMILY_FONT_CONTROL, FAMILY_FONT_PRIMARY, FAMILY_FONT_SECONDARY, TITLE_SIZE_5 } from '../../const/text';
import {
  PRIMARY_COLOR,
  PRIMARY_COLOR_ACTIVE,
  PRIMARY_COLOR_HOVER,
  SECONDARY_COLOR_2, SECONDARY_COLOR_4,
  SECONDARY_COLOR_5, SECONDARY_COLOR_6
} from '../../const/color';
import {ArrowIcon, CloseIcon, PlusIcon, SearchIcon, SubmitIcon} from '../../const/icons';
import { device } from '../../const/device';

export const Button = styled.button<{ small?: boolean, medium?: boolean, large?: boolean }>`
  outline: 0;
  border: 0;
  height: fit-content;
  padding: 5px 16px;
  text-align: center;
  border-radius: 2px;
  font-size: 16px;
  font-family: ${FAMILY_FONT_PRIMARY} !important;
  color: white;
  cursor: pointer;
  vertical-align: top;
  text-transform: uppercase;
  letter-spacing: 0.005em;
  
  ${({ small }) => small ? css`
    && {
      padding: 6px 16px;
      font-size: ${TITLE_SIZE_5};
      font-family: ${FAMILY_FONT_SECONDARY} !important;
    }
  ` : ''}
  
  ${({ medium }) => medium ? css`
    && {
      padding: 8px 44px;
      font-size: 16px;
    }
  ` : ''}
  
  ${({ large }) => large ? css`
    && {
      padding: 12px 44px;
      font-size: 14px;
    }
  ` : ''}
  
  
  @media (${device.mobileL}) {
    padding: 3px 10px;
    font-size: 12px;
    line-height: 18px;
  }
`;

export const PrimaryButton = styled(Button)`
  background-color: ${PRIMARY_COLOR};
  &:hover {
    background-color: ${PRIMARY_COLOR_HOVER}; 
  }
  &:active {
    background-color: ${PRIMARY_COLOR_ACTIVE};  
  }
  &:disabled {
    background-color: ${SECONDARY_COLOR_5};
    color: ${SECONDARY_COLOR_2};
  }
`;

export const OutlinedButton = styled(Button)`
  background-color: transparent;
  color: black;
  border: 1px solid black;

  &:hover {
    background-color: black;
    color: white;
  }

  &:active {
    background-color: #585858;
    color: white;
  }

  &:disabled {
    background-color: black;
    color: white;
    opacity: 0.5;
  }
`;

export const AdditionButton = styled.button<{disable?:string}>`
  outline: 0;
  border: 0;
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  box-shadow: 10px 24px 42px rgba(206, 208, 217, 0.5);
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  z-index:1;

  opacity: ${props => props.disable === "true" ? "0.5" : "1"};
  pointer-events: ${props => props.disable === "true" ? "none" : "auto"};
  
  &:before {
    content: '';
    position: absolute;
    pointer-events: none;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: url("data:image/svg+xml,${PlusIcon()}") center / 18px no-repeat;
  }
  
  &:hover {
    background: ${SECONDARY_COLOR_5};
  }
  &:active {
    background: ${SECONDARY_COLOR_4};
  }
`;

export const ButtonIcon = styled.button<{ icon: string, disabled?: boolean, tabletOnly?: boolean, mobileOnly?: boolean }>`
  width: 32px;
  height: 32px;
  position: relative;
  border-radius: 2px;
  outline: 0;
  border: 0;
  padding: 0;
  background-color: ${SECONDARY_COLOR_6};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml,${props => props.icon}") no-repeat center;
    pointer-events: none;
  }
  
  &:hover {
    background-color: ${SECONDARY_COLOR_5};  
  }
  &:active {
    background-color: ${SECONDARY_COLOR_4};  
  }
  opacity: ${props => props.disabled ? 0.5 : 1};
  
  ${props => props.tabletOnly ? css`
    display: none;
    @media (${device.tablet}) {
      display: inline-block;
    }
  ` : ''}
  ${props => props.mobileOnly ? css`
    display: none;
    @media (${device.mobileL}) {
      display: inline-block;
    }
  ` : ''}
  
  
  @media (${device.mobileL}) {
    width: 24px;
    height: 24px;
  }
`;

export const ButtonIconSubmit = styled(ButtonIcon).attrs({ icon: SubmitIcon(), areaLabel: 'Submit button' })`
  background-color: ${PRIMARY_COLOR};
  &:hover {
    background-color: ${PRIMARY_COLOR_HOVER};  
  }
  &:active {
    background-color: ${PRIMARY_COLOR_ACTIVE};  
  }
`;
export const ButtonIconClose = styled(ButtonIcon).attrs({ icon: CloseIcon(), areaLabel: 'Close button' })``;
export const ButtonIconLeftArrow = styled(ButtonIcon).attrs({ icon: ArrowIcon(), areaLabel: 'Left button' })``;
export const ButtonIconRightArrow = styled(ButtonIcon).attrs({ icon: ArrowIcon(), areaLabel: 'Right button' })`
  &:before {
    transform: rotate(180deg);
  }
`;


export const SearchButton = styled.button`
    width: 48px;
    background:${PRIMARY_COLOR} center / 22px no-repeat; 
    background-image: url("data:image/svg+xml,${SearchIcon("#ffffff")}");
    border: none;
    outline: none;
  
  &:hover{
    cursor:pointer;
    background-color:${PRIMARY_COLOR_HOVER}
  }
`;

export const TextButton = styled.p<{ weight?: string}>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: ${props => props.weight};
  font-family: ${FAMILY_FONT_CONTROL};
  color: #000;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #007bff;
  }
`;